import { render } from "./SubNav.vue?vue&type=template&id=63b0be88"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"

import "./SubNav.vue?vue&type=style&index=0&id=63b0be88&lang=css"
script.render = render

export default script